import * as React from 'react';
import s from '../ChangePlanModal.scss';
import { Text } from '@wix/design-system';
import { ChangePlanPlanDetails } from '../../../ChangePlanTypes';
import { Translation } from 'react-i18next';
import { DateTimeFormatter } from '@wix/premium-react-text';
import { RootStore, withInjectedRootStore } from '../../../../../providers';
import { Experiments } from 'enums';

interface PlanRenwalProps {
  planDetails: ChangePlanPlanDetails;
  amount?: number;
  isCurrentPlan: boolean;
  rootStore: RootStore;
}

export const PlanRenwalComp: React.FC<PlanRenwalProps> = ({
  planDetails,
  amount,
  isCurrentPlan,
  rootStore,
}) => {
  const { experiments } = rootStore.appStore.appContext;
  const isChangePlanExtendContentFixEnabled =
    experiments[Experiments.ChangePlanExtendContentFix] === 'true';

  return (
    <DateTimeFormatter
      dateFormat='longMonth'
      render={(formatDate) => (
        <Translation>
          {(t) => (
            <div className={s.extendBox} data-testid='renews_on'>
              <Text size='small'>
                {t('change_plan.change_plan_modal.renews_on', {
                  date: formatDate(planDetails.endOfPeriod),
                })}
              </Text>
              {!isCurrentPlan &&
                (isChangePlanExtendContentFixEnabled ? !!amount : true) && (
                  <Text size='small' skin='success' data-testid='days_added'>
                    &nbsp;
                    {t('change_plan.change_plan_modal.renew_for_days', {
                      amount,
                    })}
                  </Text>
                )}
            </div>
          )}
        </Translation>
      )}
    />
  );
};

export const PlanRenwal = withInjectedRootStore(PlanRenwalComp);
